import { WizardPage } from '../../components/wizard/types';
import { RegistrationTypeModel } from '../../api/models';
import { registrationTypeRadioOptions } from '../CommonComponentProps/registrationTypeRadioOptions';
import { FieldModel } from '../../components/form/pageForm/types';

const afiAppGuidanceText: FieldModel<RegistrationTypeModel> = {
    component: 'globalContent',
    label: '',
    name: 'afiAppGuidanceText',
    contentKey: ['AFIAppGuidanceText'],
};

const pagePrefilledMessage: FieldModel<RegistrationTypeModel> = {
    component: 'pageWarningMessage',
    name: 'prefilledMessage',
    label: 'prefilled message',
    contentKey: ['PagePrefilledMessage'],
    componentProps: {
        linkField: 'isPrefilled',
    },
};

const registrationType: WizardPage<RegistrationTypeModel> = {
    apiEndpoint: '/registration-type',
    name: 'registrationType',
    title: 'Registration type',
    enablingPages: [
    ],
    fields: {
        afiAppGuidanceText,
        pagePrefilledMessage,
        organisationIncorporatedType: {
            component: 'radiobuttonGroup',
            label: 'Is the company registered with the Australian Securities and Investments Commission?',
            name: 'organisationIncorporatedType',
            contentKey: ['organisationIncorporatedType'],
            componentProps: {
                name: 'organisationIncorporatedType',
                radioOptions: registrationTypeRadioOptions,
            },
        },
    },
    initialPageValues: {
        companyAbn: undefined,
        organisationIncorporatedType: undefined,
        isPrefilled: undefined,
    },
};

export default registrationType;
